const convertDate = (args) => {
  if (args) {
    const dt = args.split("T")[0];
    const date = new Date(dt).getUTCDate();
    const month = new Date(dt).getUTCMonth() + 1;
    const year = new Date(dt).getUTCFullYear();
    return `${date}-${month}-${year}`;
  } else {
    return "";
  }
};

function calculatePercentage(total, number) {
  const percentage = (parseInt(number) / parseInt(total)) * 100;
  return Math.round(percentage);
};

const getReferralUrl = (userInfo) => {
  return `${window.location.origin}/signup?referrer_code=${userInfo?.refCode}`;
};

function isRemainingExpired(expireDate) {
  if (!expireDate) {
    return false;
  };
  
  // Parse the provided expiry date and set it to the end of the day (EOD)
  const expiration = new Date(expireDate);
  expiration.setUTCHours(23, 59, 59, 999); // Set to the last millisecond of the day

  const today = new Date();
  return today > expiration;
};

export { calculatePercentage, convertDate, getReferralUrl, isRemainingExpired };

